<script>
import LoginForm from "../../molecules/Login/LoginForm.vue";
import Modal from "../../../../theme/organisms/Modal.vue";

export default {
    name: "LoginModal",
    components: {LoginForm, Modal},
    props: {
        candidate: {
            type: Object,
            required: false
        },
        errors: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            loginCandidate: null,
            modal: false
        }
    },
    methods: {
        open(candidate) {
            this.loginCandidate = candidate;
            this.modal = true;
        },
        close() {
            this.modal = false;
        }
    }
}
</script>

<template>
    <modal v-model="modal" ref="modal" size="md" >
        <div class="d-flex h-100 align-items-center">
            <login-form v-on="$listeners" :candidate="loginCandidate" :errors="errors" />
        </div>
    </modal>
</template>
